export const LINKS = {
  home: "home",
  about: "about",
  services: "services",
  // experiences: "experiences",
  portfolio: "portfolio",
  articles: "articles",
  contact: "contact",
};
